<template>
  <div class="share-friends-wrapper" v-if="enabled">
    <div class="row-small-gutters">
      <div class="col text-center share-friends-container">
        <button class="close" @click="dismissBanner"></button>
        <h3>{{ $t('pages.checkins_detail.share_friend_title') }}</h3>
        <h5>{{ $t('pages.checkins_detail.share_friend_text') }}</h5>
        <ul class="list-inline mt-4">
          <li class="list-inline-item">
            <CopyText :clipboard="url.replace('[network]', 'clipboard')"
                      :confirm-title="$t('pages.checkins_detail.copied_title')"
                      :confirm-message="$t('pages.checkins_detail.copied_text')" />
          </li>
          <li class="list-inline-item" v-for="(network, index) in socialNetworksList" :key="index">
            <Sharer :event-name="eventName"
                    :url-to-share="url"
                    :network="network"
                    :link-class="'list-inline-item'"
                    @click="trackShare(network)">
            </Sharer>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>


<script>
import {observeElement} from "@/utils/media";
import {socialNetworks, socialNetworksList} from "@/domain/checkinDetail/constants";
import Sharer from "@/components/Sharer.vue";
import CopyText from "@/domain/core/CopyText.vue";
import Message from "@/domain/metrics/message";

export default {
  name: 'ShareWithFriends',
  components: {CopyText, Sharer},
  props: {
    data: {
      type: Object,
      required: false,
    },
    eventName: {
      type: String,
      required: true
    }
  },
  computed: {
    enabled() {
      return this.data && this.data.enabled
    },
    url() {
      return this.data.url
    },
    socialNetworksList() {
      return socialNetworksList.filter(network => network !== socialNetworks.TWITTER)
    }
  },
  data() {
    return {
      htmlWrapper: null
    }
  },

  async mounted() {
    this.htmlWrapper = document.querySelector('.share-friends-wrapper')
    await observeElement(this.htmlWrapper, 3000)
  },
  methods: {
    dismissBanner() {
      this.htmlWrapper.classList.add('off')
    },
    trackShare(network) {
      Message.createShareWithFriend(network.name)
    },
  }
}
</script>
